import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import { actions as actionCreators  } from './models';
import { Route, Switch } from 'react-router';
import { LocaleProvider } from 'antd';
import { BrowserRouter as Router, Redirect } from 'react-router-dom';
import http from './utils/http';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment';
import momentConfig from './config/zh_cn';
import routes, { matchRouteByPath } from './routes';
import { joinRouteTitles } from './utils/helper';

import 'purecss/build/base-min.css?raw';
import 'purecss/build/grids-min.css?raw';
import 'braft-editor/dist/index.css?raw';

moment.defineLocale('zh-cn', momentConfig);

class App extends Component {
  render() {
    const store = configureStore();
    const { dispatch, getState } = store;
    const actions = bindActionCreators(actionCreators, dispatch);
    http();
    return (
      <LocaleProvider locale={zh_CN}>
        <Provider store={store}>
          <Router>
            <Switch>
              {
                routes.map((route, idx) => {
                  return (
                    <Route 
                      key={idx}
                      path={route.path}
                      exact= {route.exact === undefined ? true : route.exact}
                      strict= {route.strict === undefined ? false : route.strict}
                      render={(props) => {
                        /* 任意一个路由（包括子路由）的变化都会触发这个render函数的执行 */
                        const redirect = {};
                        const requestPath = props.location.pathname;
                        // 页面重定向
                        if (redirect.url) {
                          return (
                              <Redirect
                                  to={{
                                      pathname: redirect.url,
                                      state: { from: props.location }
                                  }}
                              />
                          );
                        }
                        const { component:Component, title:routeTitle } = route;
                        const { getPageTitle=()=>{} } = Component;
                        const assignProps = Object.assign({}, props, actions);
                        
                        // Match Route Configs
                        const matchResults = matchRouteByPath(requestPath);
                        // Join all Routes's Titles from Match Results
                        const joinsTitle = joinRouteTitles(matchResults);
                        // Change Document Title
                        document.title =
                        joinsTitle ||
                        getPageTitle(assignProps) ||
                        routeTitle;

                        return(
                          <Component {...props} />
                        );
                      }}
                    />
                  )
                })
              }
            </Switch>
          </Router>
        </Provider>
      </LocaleProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js